import type { Experiments, ExperimentsWithChoice } from '~/types/abtest'
import { buildAbtestInlineScript } from '~/utils/abtest'

export default defineNuxtPlugin(() => {
  const storageKey = 'ABTest'
  /*
  Currently, there should be maximum 1 experiment,
  because the dataLayer pushes a string like this:
  dataLayer.push({ ab_test: 'someExperiment_someValue' });
  */
  const experiments: Experiments = {
    // trustpilot: ['with', 'without']
    showSearchFormOnProductPage: ['yes', 'no']
  }
  useHead({
    script: [
      {
        innerHTML: buildAbtestInlineScript(storageKey, experiments),
        tagPriority: 'critical'
      }
    ]
  })

  let choices = {} as Record<string, string>

  if (import.meta.client) {
    const webStorage = new WebStorage()
    choices = webStorage.items[storageKey].get()
  }

  const experimentsWithChoice: ExperimentsWithChoice = {}

  for (const key in experiments) {
    experimentsWithChoice[key] = {
      variants: experiments[key],
      choice: choices[key] || null
    }
  }

  const experimentsRef = ref(experimentsWithChoice)

  const saveExperiment = (key: string, value: string) => {
    experimentsRef.value[key].choice = value
    const choices = Object.fromEntries(
      Object.entries(experimentsRef.value).map(([key, value]) => [key, value.choice])
    )
    localStorage.setItem(storageKey, JSON.stringify(choices))
  }

  return {
    provide: {
      abtest: { experiments: experimentsWithChoice, experimentsRef, saveExperiment }
    }
  }
})
